import React from 'react';
import { useOrder } from '../../context/OrderContext';

// Profiles limited to 3m bars only
const PROFILES_ONLY_3M = ['176', '186', '6S'];

const SupplyTypeSelector = ({ onSelect }) => {
    const { state } = useOrder();
    const profileType = state.orderDetails?.profileType || '';
    const isOnly3m = PROFILES_ONLY_3M.includes(profileType);

    const supplyTypes = [
        {
            id: 'barre',
            title: 'FORNITURA A BARRE',
            description: isOnly3m
                ? 'Fornitura standard in barre da 3 metri con passo foro o fresatura standard'
                : 'Fornitura standard in barre da 3 o 6 metri con passo foro o fresatura standard'
        },
        {
            id: 'misura',
            title: 'FORNITURA A MISURA',
            description: 'Fornitura taglio dritto su misura senza foro o fresatura scarico'
        },
        {
            id: 'progettazione',
            title: 'FORNITURA CON PROGETTAZIONE',
            description: 'Fornitura con servizio di progettazione'
        }
    ];

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold text-center mb-6">SEZIONE LAVORAZIONI</h2>
            <div className="space-y-4">
                {supplyTypes.map((type) => (
                    <button
                        key={type.id}
                        onClick={() => onSelect(type.id)}
                        className="w-full p-6 border-2 border-gray-200 rounded-lg hover:border-red-500
                     transition-colors duration-200 text-center"
                    >
                        <h3 className="text-lg font-medium mb-2">{type.title}</h3>
                        <p className="text-gray-600 text-sm">{type.description}</p>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SupplyTypeSelector;
